//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class FileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Uploads a file to blob storage
     * @param targetContainer The container name to upload to
     * @param fileName (optional) Optional file name to use
     * @param folder (optional) Optional folder path within container
     * @param body The file content to upload
     * @return The FileRecord ID of the uploaded file
     */
    uploadFile(targetContainer: string, fileName: string | null | undefined, folder: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/file/{targetContainer}/upload?";
        if (targetContainer === undefined || targetContainer === null)
            throw new globalThis.Error("The parameter 'targetContainer' must be defined.");
        url_ = url_.replace("{targetContainer}", encodeURIComponent("" + targetContainer));
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (folder !== undefined && folder !== null)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Gets file information and a SAS URL
     * @param fileRecordId The ID of the FileRecord
     * @return Data for the file
     */
    getFileUrl(fileRecordId: string, cancelToken?: CancelToken): Promise<ApiResponse_fileUrlResponseDTO> {
        let url_ = this.baseUrl + "/file/{fileRecordId}";
        if (fileRecordId === undefined || fileRecordId === null)
            throw new globalThis.Error("The parameter 'fileRecordId' must be defined.");
        url_ = url_.replace("{fileRecordId}", encodeURIComponent("" + fileRecordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileUrl(_response);
        });
    }

    protected processGetFileUrl(response: AxiosResponse): Promise<ApiResponse_fileUrlResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_fileUrlResponseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_fileUrlResponseDTO>(null as any);
    }
}

export class CountryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Countries
     * @return The list of Countries
     */
    getCountries( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Country
     * @param body The Country data to create
     * @return The newly created Country data
     */
    createCountry(body: CountryDTO, cancelToken?: CancelToken): Promise<ApiResponse_countryDTO> {
        let url_ = this.baseUrl + "/country";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCountry(_response);
        });
    }

    protected processCreateCountry(response: AxiosResponse): Promise<ApiResponse_countryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_countryDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_countryDTO>(null as any);
    }

    /**
     * Retrieve a Country by ID
     * @param id The ID of the Country to retrieve
     * @return The Country data
     */
    getCountryById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_countryDTO> {
        let url_ = this.baseUrl + "/country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountryById(_response);
        });
    }

    protected processGetCountryById(response: AxiosResponse): Promise<ApiResponse_countryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_countryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_countryDTO>(null as any);
    }

    /**
     * Update a Country by ID
     * @param id The ID of the Country to update
     * @param body The updated Country data
     * @return The updated Country data
     */
    updateCountry(id: string, body: CountryDTO, cancelToken?: CancelToken): Promise<ApiResponse_countryDTO> {
        let url_ = this.baseUrl + "/country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCountry(_response);
        });
    }

    protected processUpdateCountry(response: AxiosResponse): Promise<ApiResponse_countryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_countryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_countryDTO>(null as any);
    }

    /**
     * Delete a Country by ID
     * @param id The ID of the Country to delete
     */
    deleteCountry(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/country/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCountry(_response);
        });
    }

    protected processDeleteCountry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Countries based on criteria
     * @param body The search criteria
     * @return The search results of Countries based on the criteria
     */
    searchCountries(body: SearchRequestDTO_countrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/country/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCountries(_response);
        });
    }

    protected processSearchCountries(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Countries based on search criteria
     * @param body The search criteria
     * @return The export results of Countries based on the search criteria
     */
    exportCountries(body: SearchRequestDTO_countrySearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/country/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCountries(_response);
        });
    }

    protected processExportCountries(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CourseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Courses
     * @return The list of Courses
     */
    getCourses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/course";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourses(_response);
        });
    }

    protected processGetCourses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Course
     * @param body The Course data to create
     * @return The newly created Course data
     */
    createCourse(body: CourseDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCourse(_response);
        });
    }

    protected processCreateCourse(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_courseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Retrieve a Course by ID
     * @param id The ID of the Course to retrieve
     * @return The Course data
     */
    getCourseById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseById(_response);
        });
    }

    protected processGetCourseById(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Update a Course by ID
     * @param id The ID of the Course to update
     * @param body The updated Course data
     * @return The updated Course data
     */
    updateCourse(id: string, body: CourseDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseDTO> {
        let url_ = this.baseUrl + "/course/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCourse(_response);
        });
    }

    protected processUpdateCourse(response: AxiosResponse): Promise<ApiResponse_courseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseDTO>(null as any);
    }

    /**
     * Delete a Course by ID
     * @param id The ID of the Course to delete
     */
    deleteCourse(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/course/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCourse(_response);
        });
    }

    protected processDeleteCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Courses based on criteria
     * @param body The search criteria
     * @return The search results of Courses based on the criteria
     */
    searchCourses(body: SearchRequestDTO_courseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/course/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourses(_response);
        });
    }

    protected processSearchCourses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Get one course for its public profile page
     * @param id The ID of the course
     * @return The course
     */
    getCourseProfile(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseMinifiedDTO> {
        let url_ = this.baseUrl + "/courses/{id}/profile";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseProfile(_response);
        });
    }

    protected processGetCourseProfile(response: AxiosResponse): Promise<ApiResponse_courseMinifiedDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseMinifiedDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseMinifiedDTO>(null as any);
    }

    /**
     * Get all active courses for the public Explore map
     * @param if_None_Match (optional) ETag of a previously cached response
     * @return The full explore dataset
     */
    exploreCourses(if_None_Match: string | null | undefined, cancelToken?: CancelToken): Promise<ApiResponse_courseMinifiedDTOOf> {
        let url_ = this.baseUrl + "/courses/explore";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "If-None-Match": if_None_Match !== undefined && if_None_Match !== null ? "" + if_None_Match : "",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExploreCourses(_response);
        });
    }

    protected processExploreCourses(response: AxiosResponse): Promise<ApiResponse_courseMinifiedDTOOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseMinifiedDTOOf>(result200);

        } else if (status === 304) {
            const _responseText = response.data;
            return throwException("The client\'s cached copy is still current", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseMinifiedDTOOf>(null as any);
    }

    /**
     * Pointer to the published Explore dataset
     * @return The current snapshot manifest
     */
    exploreManifest( cancelToken?: CancelToken): Promise<ApiResponse_exploreManifestDTO> {
        let url_ = this.baseUrl + "/courses/explore/manifest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExploreManifest(_response);
        });
    }

    protected processExploreManifest(response: AxiosResponse): Promise<ApiResponse_exploreManifestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exploreManifestDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("No snapshot has been published yet", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exploreManifestDTO>(null as any);
    }

    /**
     * Force a rebuild of the Explore snapshot
     * @return The result of the rebuild
     */
    republishExploreSnapshot( cancelToken?: CancelToken): Promise<ApiResponse_exploreSnapshotResultDTO> {
        let url_ = this.baseUrl + "/courses/explore/republish";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRepublishExploreSnapshot(_response);
        });
    }

    protected processRepublishExploreSnapshot(response: AxiosResponse): Promise<ApiResponse_exploreSnapshotResultDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_exploreSnapshotResultDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_exploreSnapshotResultDTO>(null as any);
    }

    /**
     * Export Courses based on search criteria
     * @param body The search criteria
     * @return The export results of Courses based on the search criteria
     */
    exportCourses(body: SearchRequestDTO_courseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/course/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportCourses(_response);
        });
    }

    protected processExportCourses(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class CourseRequestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Ask for a missing course to be added
     * @param body The course the member is looking for
     * @return The filed request
     */
    requestCourse(body: CourseRequestCreateDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseRequestDTO> {
        let url_ = this.baseUrl + "/member/me/course-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestCourse(_response);
        });
    }

    protected processRequestCourse(response: AxiosResponse): Promise<ApiResponse_courseRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseRequestDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseRequestDTO>(null as any);
    }

    /**
     * Search course requests
     * @param body The search criteria
     * @return The matching course requests
     */
    searchCourseRequests(body: SearchRequestDTO_courseRequestSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/course-request/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCourseRequests(_response);
        });
    }

    protected processSearchCourseRequests(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve a course request by ID
     * @param id The ID of the course request
     * @return The course request
     */
    getCourseRequestById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_courseRequestDTO> {
        let url_ = this.baseUrl + "/course-request/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCourseRequestById(_response);
        });
    }

    protected processGetCourseRequestById(response: AxiosResponse): Promise<ApiResponse_courseRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseRequestDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseRequestDTO>(null as any);
    }

    /**
     * Approve a course request
     * @param id The ID of the course request
     * @param body The course to link, and an optional note
     * @return The approved request
     */
    approveCourseRequest(id: string, body: CourseRequestReviewDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseRequestDTO> {
        let url_ = this.baseUrl + "/course-request/{id}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveCourseRequest(_response);
        });
    }

    protected processApproveCourseRequest(response: AxiosResponse): Promise<ApiResponse_courseRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseRequestDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseRequestDTO>(null as any);
    }

    /**
     * Decline a course request
     * @param id The ID of the course request
     * @param body An optional note on why
     * @return The declined request
     */
    declineCourseRequest(id: string, body: CourseRequestReviewDTO, cancelToken?: CancelToken): Promise<ApiResponse_courseRequestDTO> {
        let url_ = this.baseUrl + "/course-request/{id}/decline";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclineCourseRequest(_response);
        });
    }

    protected processDeclineCourseRequest(response: AxiosResponse): Promise<ApiResponse_courseRequestDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_courseRequestDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_courseRequestDTO>(null as any);
    }
}

export class InvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Invoices
     * @return The list of Invoices
     */
    getInvoices( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/invoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve an Invoice by ID
     * @param id The ID of the Invoice to retrieve
     * @return The Invoice data
     */
    getInvoiceById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceById(_response);
        });
    }

    protected processGetInvoiceById(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Delete an Invoice by ID
     * @param id The ID of the Invoice to delete
     */
    deleteInvoice(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/invoice/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteInvoice(_response);
        });
    }

    protected processDeleteInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Invoices based on criteria
     * @param body The search criteria
     * @return The search results of Invoices based on the criteria
     */
    searchInvoices(body: SearchRequestDTO_invoiceSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/invoice/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchInvoices(_response);
        });
    }

    protected processSearchInvoices(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Invoices based on search criteria
     * @param body The search criteria
     * @return The export results of Invoices based on the search criteria
     */
    exportInvoices(body: SearchRequestDTO_invoiceSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoice/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportInvoices(_response);
        });
    }

    protected processExportInvoices(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Create an Invoice for a Member's fee
     * @param memberId The Member being invoiced
     * @param memberFeeId The MemberFee being charged
     * @return The newly created Invoice
     */
    createInvoiceForMemberFee(memberId: string, memberFeeId: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/create-for-member-fee?";
        if (memberId === undefined || memberId === null)
            throw new globalThis.Error("The parameter 'memberId' must be defined and cannot be null.");
        else
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        if (memberFeeId === undefined || memberFeeId === null)
            throw new globalThis.Error("The parameter 'memberFeeId' must be defined and cannot be null.");
        else
            url_ += "memberFeeId=" + encodeURIComponent("" + memberFeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceForMemberFee(_response);
        });
    }

    protected processCreateInvoiceForMemberFee(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_invoiceDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }

    /**
     * Retrieve the public payment summary for an Invoice
     * @param id The ID of the Invoice
     * @return The payment summary
     */
    getInvoicePaymentSummary(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoicePaymentSummaryDTO> {
        let url_ = this.baseUrl + "/invoice/{id}/payment-summary";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePaymentSummary(_response);
        });
    }

    protected processGetInvoicePaymentSummary(response: AxiosResponse): Promise<ApiResponse_invoicePaymentSummaryDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoicePaymentSummaryDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoicePaymentSummaryDTO>(null as any);
    }

    /**
     * Create a Stripe Checkout Session for an Invoice
     * @param id The ID of the Invoice to pay
     * @return The Stripe Checkout URL to redirect the browser to
     */
    createCheckoutSession(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/invoice/{id}/checkout-session";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCheckoutSession(_response);
        });
    }

    protected processCreateCheckoutSession(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Mark an Invoice as paid
     * @param id The ID of the Invoice to mark as paid
     * @return The updated Invoice
     */
    markInvoiceAsPaid(id: string, cancelToken?: CancelToken): Promise<ApiResponse_invoiceDTO> {
        let url_ = this.baseUrl + "/invoice/{id}/mark-paid";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkInvoiceAsPaid(_response);
        });
    }

    protected processMarkInvoiceAsPaid(response: AxiosResponse): Promise<ApiResponse_invoiceDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_invoiceDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_invoiceDTO>(null as any);
    }
}

export class MemberBucketListClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get the logged-in member's bucket list
     * @return The current member's bucket list
     */
    getMyBucketList( cancelToken?: CancelToken): Promise<ApiResponse_memberBucketListSummaryDTOOf> {
        let url_ = this.baseUrl + "/member/me/bucket-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyBucketList(_response);
        });
    }

    protected processGetMyBucketList(response: AxiosResponse): Promise<ApiResponse_memberBucketListSummaryDTOOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberBucketListSummaryDTOOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberBucketListSummaryDTOOf>(null as any);
    }

    /**
     * Add a course to the logged-in member's bucket list
     * @param courseId The ID of the course
     * @return Whether the course is now on the list
     */
    addCourseToMyBucketList(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/bucket-list/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCourseToMyBucketList(_response);
        });
    }

    protected processAddCourseToMyBucketList(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Remove a course from the logged-in member's bucket list
     * @param courseId The ID of the course
     * @return Whether the course is now on the list
     */
    removeCourseFromMyBucketList(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/bucket-list/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCourseFromMyBucketList(_response);
        });
    }

    protected processRemoveCourseFromMyBucketList(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Retrieve all MemberBucketLists
     * @return The list of MemberBucketLists
     */
    getMemberBucketLists( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberbucketlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberBucketLists(_response);
        });
    }

    protected processGetMemberBucketLists(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberBucketList
     * @param body The MemberBucketList data to create
     * @return The newly created MemberBucketList data
     */
    createMemberBucketList(body: MemberBucketListDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberBucketListDTO> {
        let url_ = this.baseUrl + "/memberbucketlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberBucketList(_response);
        });
    }

    protected processCreateMemberBucketList(response: AxiosResponse): Promise<ApiResponse_memberBucketListDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberBucketListDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberBucketListDTO>(null as any);
    }

    /**
     * Retrieve a MemberBucketList by ID
     * @param id The ID of the MemberBucketList to retrieve
     * @return The MemberBucketList data
     */
    getMemberBucketListById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberBucketListDTO> {
        let url_ = this.baseUrl + "/memberbucketlist/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberBucketListById(_response);
        });
    }

    protected processGetMemberBucketListById(response: AxiosResponse): Promise<ApiResponse_memberBucketListDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberBucketListDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberBucketListDTO>(null as any);
    }

    /**
     * Update a MemberBucketList by ID
     * @param id The ID of the MemberBucketList to update
     * @param body The updated MemberBucketList data
     * @return The updated MemberBucketList data
     */
    updateMemberBucketList(id: string, body: MemberBucketListDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberBucketListDTO> {
        let url_ = this.baseUrl + "/memberbucketlist/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberBucketList(_response);
        });
    }

    protected processUpdateMemberBucketList(response: AxiosResponse): Promise<ApiResponse_memberBucketListDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberBucketListDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberBucketListDTO>(null as any);
    }

    /**
     * Delete a MemberBucketList by ID
     * @param id The ID of the MemberBucketList to delete
     */
    deleteMemberBucketList(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberbucketlist/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberBucketList(_response);
        });
    }

    protected processDeleteMemberBucketList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberBucketLists based on criteria
     * @param body The search criteria
     * @return The search results of MemberBucketLists based on the criteria
     */
    searchMemberBucketLists(body: SearchRequestDTO_memberBucketListSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberbucketlist/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberBucketLists(_response);
        });
    }

    protected processSearchMemberBucketLists(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberBucketLists based on search criteria
     * @param body The search criteria
     * @return The export results of MemberBucketLists based on the search criteria
     */
    exportMemberBucketLists(body: SearchRequestDTO_memberBucketListSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberbucketlist/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberBucketLists(_response);
        });
    }

    protected processExportMemberBucketLists(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberCoursesPlayedClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get the logged-in member's dashboard stats
     * @return The member's stats
     */
    getMyStats( cancelToken?: CancelToken): Promise<ApiResponse_memberStatsDTO> {
        let url_ = this.baseUrl + "/member/me/stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyStats(_response);
        });
    }

    protected processGetMyStats(response: AxiosResponse): Promise<ApiResponse_memberStatsDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberStatsDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberStatsDTO>(null as any);
    }

    /**
     * Get the logged-in member's played courses
     * @return The current member's played courses
     */
    getMyCoursesPlayed( cancelToken?: CancelToken): Promise<ApiResponse_memberCoursesPlayedSummaryDTOOf> {
        let url_ = this.baseUrl + "/member/me/courses-played";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyCoursesPlayed(_response);
        });
    }

    protected processGetMyCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_memberCoursesPlayedSummaryDTOOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCoursesPlayedSummaryDTOOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCoursesPlayedSummaryDTOOf>(null as any);
    }

    /**
     * Mark a course played for the logged-in member
     * @param courseId The ID of the course
     * @return Whether the course is now on the list
     */
    addCourseToMyCoursesPlayed(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/courses-played/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCourseToMyCoursesPlayed(_response);
        });
    }

    protected processAddCourseToMyCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("The free tier is full. Upgrade to add more.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Unmark a course played for the logged-in member
     * @param courseId The ID of the course
     * @return Whether the course is now on the list
     */
    removeCourseFromMyCoursesPlayed(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/courses-played/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCourseFromMyCoursesPlayed(_response);
        });
    }

    protected processRemoveCourseFromMyCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Save the logged-in member's ranking of their played courses
     * @param body The course ids in rank order
     * @return The ranking was saved
     */
    setMyCoursesPlayedRank(body: MemberCoursesPlayedRankRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/courses-played/rank";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMyCoursesPlayedRank(_response);
        });
    }

    protected processSetMyCoursesPlayedRank(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Rank one of the logged-in member's played courses
     * @param courseId The ID of the course
     * @param body The sentiment and the place
     * @return The course's new rank, 1 being the favourite
     */
    placeMyCoursePlayed(courseId: string, body: MemberCoursesPlayedPlaceRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_int32> {
        let url_ = this.baseUrl + "/member/me/courses-played/{courseId}/place";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPlaceMyCoursePlayed(_response);
        });
    }

    protected processPlaceMyCoursePlayed(response: AxiosResponse): Promise<ApiResponse_int32> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_int32>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_int32>(null as any);
    }

    /**
     * Get the logged-in member's sharing state
     * @return The sharing state
     */
    getMyCoursesPlayedShare( cancelToken?: CancelToken): Promise<ApiResponse_coursesPlayedShareDTO> {
        let url_ = this.baseUrl + "/member/me/courses-played/share";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyCoursesPlayedShare(_response);
        });
    }

    protected processGetMyCoursesPlayedShare(response: AxiosResponse): Promise<ApiResponse_coursesPlayedShareDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_coursesPlayedShareDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_coursesPlayedShareDTO>(null as any);
    }

    /**
     * Turn on sharing of the logged-in member's played courses
     * @return The sharing state
     */
    shareMyCoursesPlayed( cancelToken?: CancelToken): Promise<ApiResponse_coursesPlayedShareDTO> {
        let url_ = this.baseUrl + "/member/me/courses-played/share";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShareMyCoursesPlayed(_response);
        });
    }

    protected processShareMyCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_coursesPlayedShareDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_coursesPlayedShareDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_coursesPlayedShareDTO>(null as any);
    }

    /**
     * Turn off sharing of the logged-in member's played courses
     * @return The sharing state
     */
    stopSharingMyCoursesPlayed( cancelToken?: CancelToken): Promise<ApiResponse_coursesPlayedShareDTO> {
        let url_ = this.baseUrl + "/member/me/courses-played/share";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopSharingMyCoursesPlayed(_response);
        });
    }

    protected processStopSharingMyCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_coursesPlayedShareDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_coursesPlayedShareDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_coursesPlayedShareDTO>(null as any);
    }

    /**
     * Get a member's shared Courses Played list
     * @param shareId The share code from the link
     * @return The shared list
     */
    getSharedCoursesPlayed(shareId: string, cancelToken?: CancelToken): Promise<ApiResponse_sharedCoursesPlayedDTO> {
        let url_ = this.baseUrl + "/shared/courses-played/{shareId}";
        if (shareId === undefined || shareId === null)
            throw new globalThis.Error("The parameter 'shareId' must be defined.");
        url_ = url_.replace("{shareId}", encodeURIComponent("" + shareId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedCoursesPlayed(_response);
        });
    }

    protected processGetSharedCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_sharedCoursesPlayedDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_sharedCoursesPlayedDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_sharedCoursesPlayedDTO>(null as any);
    }

    /**
     * Retrieve all MemberCoursesPlayeds
     * @return The list of MemberCoursesPlayeds
     */
    getMemberCoursesPlayeds( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membercoursesplayed";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCoursesPlayeds(_response);
        });
    }

    protected processGetMemberCoursesPlayeds(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberCoursesPlayed
     * @param body The MemberCoursesPlayed data to create
     * @return The newly created MemberCoursesPlayed data
     */
    createMemberCoursesPlayed(body: MemberCoursesPlayedDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCoursesPlayedDTO> {
        let url_ = this.baseUrl + "/membercoursesplayed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberCoursesPlayed(_response);
        });
    }

    protected processCreateMemberCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_memberCoursesPlayedDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberCoursesPlayedDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCoursesPlayedDTO>(null as any);
    }

    /**
     * Retrieve a MemberCoursesPlayed by ID
     * @param id The ID of the MemberCoursesPlayed to retrieve
     * @return The MemberCoursesPlayed data
     */
    getMemberCoursesPlayedById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberCoursesPlayedDTO> {
        let url_ = this.baseUrl + "/membercoursesplayed/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberCoursesPlayedById(_response);
        });
    }

    protected processGetMemberCoursesPlayedById(response: AxiosResponse): Promise<ApiResponse_memberCoursesPlayedDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCoursesPlayedDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCoursesPlayedDTO>(null as any);
    }

    /**
     * Update a MemberCoursesPlayed by ID
     * @param id The ID of the MemberCoursesPlayed to update
     * @param body The updated MemberCoursesPlayed data
     * @return The updated MemberCoursesPlayed data
     */
    updateMemberCoursesPlayed(id: string, body: MemberCoursesPlayedDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberCoursesPlayedDTO> {
        let url_ = this.baseUrl + "/membercoursesplayed/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberCoursesPlayed(_response);
        });
    }

    protected processUpdateMemberCoursesPlayed(response: AxiosResponse): Promise<ApiResponse_memberCoursesPlayedDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberCoursesPlayedDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberCoursesPlayedDTO>(null as any);
    }

    /**
     * Delete a MemberCoursesPlayed by ID
     * @param id The ID of the MemberCoursesPlayed to delete
     */
    deleteMemberCoursesPlayed(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membercoursesplayed/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberCoursesPlayed(_response);
        });
    }

    protected processDeleteMemberCoursesPlayed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberCoursesPlayeds based on criteria
     * @param body The search criteria
     * @return The search results of MemberCoursesPlayeds based on the criteria
     */
    searchMemberCoursesPlayeds(body: SearchRequestDTO_memberCoursesPlayedSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membercoursesplayed/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberCoursesPlayeds(_response);
        });
    }

    protected processSearchMemberCoursesPlayeds(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberCoursesPlayeds based on search criteria
     * @param body The search criteria
     * @return The export results of MemberCoursesPlayeds based on the search criteria
     */
    exportMemberCoursesPlayeds(body: SearchRequestDTO_memberCoursesPlayedSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/membercoursesplayed/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberCoursesPlayeds(_response);
        });
    }

    protected processExportMemberCoursesPlayeds(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberFeeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all MemberFees
     * @return The list of MemberFees
     */
    getMemberFees( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberfee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberFees(_response);
        });
    }

    protected processGetMemberFees(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberFee
     * @param body The MemberFee data to create
     * @return The newly created MemberFee data
     */
    createMemberFee(body: MemberFeeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberFeeDTO> {
        let url_ = this.baseUrl + "/memberfee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberFee(_response);
        });
    }

    protected processCreateMemberFee(response: AxiosResponse): Promise<ApiResponse_memberFeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberFeeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFeeDTO>(null as any);
    }

    /**
     * Retrieve a MemberFee by ID
     * @param id The ID of the MemberFee to retrieve
     * @return The MemberFee data
     */
    getMemberFeeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberFeeDTO> {
        let url_ = this.baseUrl + "/memberfee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberFeeById(_response);
        });
    }

    protected processGetMemberFeeById(response: AxiosResponse): Promise<ApiResponse_memberFeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberFeeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFeeDTO>(null as any);
    }

    /**
     * Update a MemberFee by ID
     * @param id The ID of the MemberFee to update
     * @param body The updated MemberFee data
     * @return The updated MemberFee data
     */
    updateMemberFee(id: string, body: MemberFeeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberFeeDTO> {
        let url_ = this.baseUrl + "/memberfee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberFee(_response);
        });
    }

    protected processUpdateMemberFee(response: AxiosResponse): Promise<ApiResponse_memberFeeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberFeeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberFeeDTO>(null as any);
    }

    /**
     * Delete a MemberFee by ID
     * @param id The ID of the MemberFee to delete
     */
    deleteMemberFee(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberfee/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberFee(_response);
        });
    }

    protected processDeleteMemberFee(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberFees based on criteria
     * @param body The search criteria
     * @return The search results of MemberFees based on the criteria
     */
    searchMemberFees(body: SearchRequestDTO_memberFeeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberfee/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberFees(_response);
        });
    }

    protected processSearchMemberFees(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberFees based on search criteria
     * @param body The search criteria
     * @return The export results of MemberFees based on the search criteria
     */
    exportMemberFees(body: SearchRequestDTO_memberFeeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberfee/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberFees(_response);
        });
    }

    protected processExportMemberFees(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberHomeCourseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get the logged-in member's home courses
     * @return The current member's home courses
     */
    getMyHomeCourses( cancelToken?: CancelToken): Promise<ApiResponse_memberHomeCourseSummaryDTOOf> {
        let url_ = this.baseUrl + "/member/me/home-courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyHomeCourses(_response);
        });
    }

    protected processGetMyHomeCourses(response: AxiosResponse): Promise<ApiResponse_memberHomeCourseSummaryDTOOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberHomeCourseSummaryDTOOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberHomeCourseSummaryDTOOf>(null as any);
    }

    /**
     * Add a home course for the logged-in member
     * @param courseId The ID of the course
     * @return Whether the course is now a home course
     */
    addCourseToMyHomeCourses(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/home-courses/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddCourseToMyHomeCourses(_response);
        });
    }

    protected processAddCourseToMyHomeCourses(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Remove a home course for the logged-in member
     * @param courseId The ID of the course
     * @return Whether the course is now a home course
     */
    removeCourseFromMyHomeCourses(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/home-courses/{courseId}";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveCourseFromMyHomeCourses(_response);
        });
    }

    protected processRemoveCourseFromMyHomeCourses(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Show or hide one of the logged-in member's home courses
     * @param courseId The ID of the course
     * @param body Whether to hide the course
     * @return Whether the course is now hidden
     */
    setMyHomeCourseVisibility(courseId: string, body: MemberHomeCourseVisibilityDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/home-courses/{courseId}/visibility";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMyHomeCourseVisibility(_response);
        });
    }

    protected processSetMyHomeCourseVisibility(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Make one of the logged-in member's home courses their primary
     * @param courseId The ID of the course
     * @return The course is now the primary
     */
    setMyPrimaryHomeCourse(courseId: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/home-courses/{courseId}/primary";
        if (courseId === undefined || courseId === null)
            throw new globalThis.Error("The parameter 'courseId' must be defined.");
        url_ = url_.replace("{courseId}", encodeURIComponent("" + courseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMyPrimaryHomeCourse(_response);
        });
    }

    protected processSetMyPrimaryHomeCourse(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Retrieve all MemberHomeCourses
     * @return The list of MemberHomeCourses
     */
    getMemberHomeCourses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/memberhomecourse";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberHomeCourses(_response);
        });
    }

    protected processGetMemberHomeCourses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberHomeCourse
     * @param body The MemberHomeCourse data to create
     * @return The newly created MemberHomeCourse data
     */
    createMemberHomeCourse(body: MemberHomeCourseDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberHomeCourseDTO> {
        let url_ = this.baseUrl + "/memberhomecourse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberHomeCourse(_response);
        });
    }

    protected processCreateMemberHomeCourse(response: AxiosResponse): Promise<ApiResponse_memberHomeCourseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberHomeCourseDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberHomeCourseDTO>(null as any);
    }

    /**
     * Retrieve a MemberHomeCourse by ID
     * @param id The ID of the MemberHomeCourse to retrieve
     * @return The MemberHomeCourse data
     */
    getMemberHomeCourseById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberHomeCourseDTO> {
        let url_ = this.baseUrl + "/memberhomecourse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberHomeCourseById(_response);
        });
    }

    protected processGetMemberHomeCourseById(response: AxiosResponse): Promise<ApiResponse_memberHomeCourseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberHomeCourseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberHomeCourseDTO>(null as any);
    }

    /**
     * Update a MemberHomeCourse by ID
     * @param id The ID of the MemberHomeCourse to update
     * @param body The updated MemberHomeCourse data
     * @return The updated MemberHomeCourse data
     */
    updateMemberHomeCourse(id: string, body: MemberHomeCourseDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberHomeCourseDTO> {
        let url_ = this.baseUrl + "/memberhomecourse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberHomeCourse(_response);
        });
    }

    protected processUpdateMemberHomeCourse(response: AxiosResponse): Promise<ApiResponse_memberHomeCourseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberHomeCourseDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberHomeCourseDTO>(null as any);
    }

    /**
     * Delete a MemberHomeCourse by ID
     * @param id The ID of the MemberHomeCourse to delete
     */
    deleteMemberHomeCourse(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/memberhomecourse/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberHomeCourse(_response);
        });
    }

    protected processDeleteMemberHomeCourse(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberHomeCourses based on criteria
     * @param body The search criteria
     * @return The search results of MemberHomeCourses based on the criteria
     */
    searchMemberHomeCourses(body: SearchRequestDTO_memberHomeCourseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/memberhomecourse/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberHomeCourses(_response);
        });
    }

    protected processSearchMemberHomeCourses(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberHomeCourses based on search criteria
     * @param body The search criteria
     * @return The export results of MemberHomeCourses based on the search criteria
     */
    exportMemberHomeCourses(body: SearchRequestDTO_memberHomeCourseSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/memberhomecourse/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberHomeCourses(_response);
        });
    }

    protected processExportMemberHomeCourses(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve active membership options for sign-up
     * @return The active membership options
     */
    getActiveMembershipOptions( cancelToken?: CancelToken): Promise<ApiResponse_membershipOptionDTOOf> {
        let url_ = this.baseUrl + "/membertype/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveMembershipOptions(_response);
        });
    }

    protected processGetActiveMembershipOptions(response: AxiosResponse): Promise<ApiResponse_membershipOptionDTOOf> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_membershipOptionDTOOf>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_membershipOptionDTOOf>(null as any);
    }

    /**
     * Retrieve all MemberTypes
     * @return The list of MemberTypes
     */
    getMemberTypes( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/membertype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTypes(_response);
        });
    }

    protected processGetMemberTypes(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new MemberType
     * @param body The MemberType data to create
     * @return The newly created MemberType data
     */
    createMemberType(body: MemberTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTypeDTO> {
        let url_ = this.baseUrl + "/membertype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMemberType(_response);
        });
    }

    protected processCreateMemberType(response: AxiosResponse): Promise<ApiResponse_memberTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberTypeDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTypeDTO>(null as any);
    }

    /**
     * Retrieve a MemberType by ID
     * @param id The ID of the MemberType to retrieve
     * @return The MemberType data
     */
    getMemberTypeById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberTypeDTO> {
        let url_ = this.baseUrl + "/membertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberTypeById(_response);
        });
    }

    protected processGetMemberTypeById(response: AxiosResponse): Promise<ApiResponse_memberTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTypeDTO>(null as any);
    }

    /**
     * Update a MemberType by ID
     * @param id The ID of the MemberType to update
     * @param body The updated MemberType data
     * @return The updated MemberType data
     */
    updateMemberType(id: string, body: MemberTypeDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberTypeDTO> {
        let url_ = this.baseUrl + "/membertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMemberType(_response);
        });
    }

    protected processUpdateMemberType(response: AxiosResponse): Promise<ApiResponse_memberTypeDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberTypeDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberTypeDTO>(null as any);
    }

    /**
     * Delete a MemberType by ID
     * @param id The ID of the MemberType to delete
     */
    deleteMemberType(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/membertype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMemberType(_response);
        });
    }

    protected processDeleteMemberType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search MemberTypes based on criteria
     * @param body The search criteria
     * @return The search results of MemberTypes based on the criteria
     */
    searchMemberTypes(body: SearchRequestDTO_memberTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/membertype/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMemberTypes(_response);
        });
    }

    protected processSearchMemberTypes(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export MemberTypes based on search criteria
     * @param body The search criteria
     * @return The export results of MemberTypes based on the search criteria
     */
    exportMemberTypes(body: SearchRequestDTO_memberTypeSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/membertype/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMemberTypes(_response);
        });
    }

    protected processExportMemberTypes(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class PinClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all Pins
     * @return The list of Pins
     */
    getPins( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/pin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPins(_response);
        });
    }

    protected processGetPins(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new Pin
     * @param body The Pin data to create
     * @return The newly created Pin data
     */
    createPin(body: PinDTO, cancelToken?: CancelToken): Promise<ApiResponse_pinDTO> {
        let url_ = this.baseUrl + "/pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePin(_response);
        });
    }

    protected processCreatePin(response: AxiosResponse): Promise<ApiResponse_pinDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_pinDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pinDTO>(null as any);
    }

    /**
     * Retrieve a Pin by ID
     * @param id The ID of the Pin to retrieve
     * @return The Pin data
     */
    getPinById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_pinDTO> {
        let url_ = this.baseUrl + "/pin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPinById(_response);
        });
    }

    protected processGetPinById(response: AxiosResponse): Promise<ApiResponse_pinDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_pinDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pinDTO>(null as any);
    }

    /**
     * Update a Pin by ID
     * @param id The ID of the Pin to update
     * @param body The updated Pin data
     * @return The updated Pin data
     */
    updatePin(id: string, body: PinDTO, cancelToken?: CancelToken): Promise<ApiResponse_pinDTO> {
        let url_ = this.baseUrl + "/pin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePin(_response);
        });
    }

    protected processUpdatePin(response: AxiosResponse): Promise<ApiResponse_pinDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_pinDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_pinDTO>(null as any);
    }

    /**
     * Delete a Pin by ID
     * @param id The ID of the Pin to delete
     */
    deletePin(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/pin/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePin(_response);
        });
    }

    protected processDeletePin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search Pins based on criteria
     * @param body The search criteria
     * @return The search results of Pins based on the criteria
     */
    searchPins(body: SearchRequestDTO_pinSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/pin/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchPins(_response);
        });
    }

    protected processSearchPins(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Pins based on search criteria
     * @param body The search criteria
     * @return The export results of Pins based on the search criteria
     */
    exportPins(body: SearchRequestDTO_pinSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/pin/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPins(_response);
        });
    }

    protected processExportPins(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class StateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all States
     * @return The list of States
     */
    getStates( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/state";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStates(_response);
        });
    }

    protected processGetStates(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new State
     * @param body The State data to create
     * @return The newly created State data
     */
    createState(body: StateDTO, cancelToken?: CancelToken): Promise<ApiResponse_stateDTO> {
        let url_ = this.baseUrl + "/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateState(_response);
        });
    }

    protected processCreateState(response: AxiosResponse): Promise<ApiResponse_stateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_stateDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_stateDTO>(null as any);
    }

    /**
     * Retrieve a State by ID
     * @param id The ID of the State to retrieve
     * @return The State data
     */
    getStateById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_stateDTO> {
        let url_ = this.baseUrl + "/state/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStateById(_response);
        });
    }

    protected processGetStateById(response: AxiosResponse): Promise<ApiResponse_stateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_stateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_stateDTO>(null as any);
    }

    /**
     * Update a State by ID
     * @param id The ID of the State to update
     * @param body The updated State data
     * @return The updated State data
     */
    updateState(id: string, body: StateDTO, cancelToken?: CancelToken): Promise<ApiResponse_stateDTO> {
        let url_ = this.baseUrl + "/state/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateState(_response);
        });
    }

    protected processUpdateState(response: AxiosResponse): Promise<ApiResponse_stateDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_stateDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_stateDTO>(null as any);
    }

    /**
     * Delete a State by ID
     * @param id The ID of the State to delete
     */
    deleteState(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/state/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteState(_response);
        });
    }

    protected processDeleteState(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search States based on criteria
     * @param body The search criteria
     * @return The search results of States based on the criteria
     */
    searchStates(body: SearchRequestDTO_stateSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/state/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchStates(_response);
        });
    }

    protected processSearchStates(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export States based on search criteria
     * @param body The search criteria
     * @return The export results of States based on the search criteria
     */
    exportStates(body: SearchRequestDTO_stateSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/state/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportStates(_response);
        });
    }

    protected processExportStates(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class StripeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Receive a Stripe webhook event
     * @return Acknowledged
     */
    stripeWebhook( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/stripe/webhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStripeWebhook(_response);
        });
    }

    protected processStripeWebhook(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class SubRegionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all SubRegions
     * @return The list of SubRegions
     */
    getSubRegions( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/subregion";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubRegions(_response);
        });
    }

    protected processGetSubRegions(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new SubRegion
     * @param body The SubRegion data to create
     * @return The newly created SubRegion data
     */
    createSubRegion(body: SubRegionDTO, cancelToken?: CancelToken): Promise<ApiResponse_subRegionDTO> {
        let url_ = this.baseUrl + "/subregion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSubRegion(_response);
        });
    }

    protected processCreateSubRegion(response: AxiosResponse): Promise<ApiResponse_subRegionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_subRegionDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_subRegionDTO>(null as any);
    }

    /**
     * Retrieve a SubRegion by ID
     * @param id The ID of the SubRegion to retrieve
     * @return The SubRegion data
     */
    getSubRegionById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_subRegionDTO> {
        let url_ = this.baseUrl + "/subregion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubRegionById(_response);
        });
    }

    protected processGetSubRegionById(response: AxiosResponse): Promise<ApiResponse_subRegionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_subRegionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_subRegionDTO>(null as any);
    }

    /**
     * Update a SubRegion by ID
     * @param id The ID of the SubRegion to update
     * @param body The updated SubRegion data
     * @return The updated SubRegion data
     */
    updateSubRegion(id: string, body: SubRegionDTO, cancelToken?: CancelToken): Promise<ApiResponse_subRegionDTO> {
        let url_ = this.baseUrl + "/subregion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSubRegion(_response);
        });
    }

    protected processUpdateSubRegion(response: AxiosResponse): Promise<ApiResponse_subRegionDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_subRegionDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_subRegionDTO>(null as any);
    }

    /**
     * Delete a SubRegion by ID
     * @param id The ID of the SubRegion to delete
     */
    deleteSubRegion(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/subregion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSubRegion(_response);
        });
    }

    protected processDeleteSubRegion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search SubRegions based on criteria
     * @param body The search criteria
     * @return The search results of SubRegions based on the criteria
     */
    searchSubRegions(body: SearchRequestDTO_subRegionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/subregion/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchSubRegions(_response);
        });
    }

    protected processSearchSubRegions(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export SubRegions based on search criteria
     * @param body The search criteria
     * @return The export results of SubRegions based on the search criteria
     */
    exportSubRegions(body: SearchRequestDTO_subRegionSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/subregion/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSubRegions(_response);
        });
    }

    protected processExportSubRegions(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class AuditLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve an audit log by ID
     * @param id The ID of the audit log to retrieve
     * @return The audit log data
     */
    getAuditLogById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_auditLogDTO> {
        let url_ = this.baseUrl + "/auditlogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogById(_response);
        });
    }

    protected processGetAuditLogById(response: AxiosResponse): Promise<ApiResponse_auditLogDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_auditLogDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_auditLogDTO>(null as any);
    }

    /**
     * Search audit logs based on criteria
     * @param body The search criteria
     * @return The search results of audit logs based on the criteria
     */
    searchAuditLogs(body: SearchRequestDTO_auditLogSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/auditlogs/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchAuditLogs(_response);
        });
    }

    protected processSearchAuditLogs(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Retrieve distinct table names
     * @return The list of distinct table names
     */
    getDistinctTableNames( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/auditlogs/tablenames";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDistinctTableNames(_response);
        });
    }

    protected processGetDistinctTableNames(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Generates a token for user authentication
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    generateToken(body: LoginUserDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateToken(_response);
        });
    }

    protected processGenerateToken(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for user authentication via two factor authentication
     * @param body Two factor auth data for token generation
     * @return JWT token for authenticated requests
     */
    generateTokenTwoFactor(body: LoginTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/token/twofactor/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateTokenTwoFactor(_response);
        });
    }

    protected processGenerateTokenTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect credentials.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Refreshes an access token
     * @param body Payload containing the refresh token
     * @return The refreshed access token, refresh token, and expiration time.
     */
    refreshToken(body: RefreshTokenDTO, cancelToken?: CancelToken): Promise<ApiResponse_authDTO> {
        let url_ = this.baseUrl + "/auth/token/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<ApiResponse_authDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_authDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request in case of invalid refresh token.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the refresh token is expired or invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_authDTO>(null as any);
    }

    /**
     * Setup Two-Factor Authentication
     * @param userId The ID of the user
     * @return TOTP setup details including QR code and secret
     */
    setupTwoFactor(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        let url_ = this.baseUrl + "/auth/{userId}/two-factor/setup";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetupTwoFactor(_response);
        });
    }

    protected processSetupTwoFactor(response: AxiosResponse): Promise<ApiResponse_twoFactorSetupResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_twoFactorSetupResponseDTO>(null as any);
    }

    /**
     * Verify Two-Factor Authentication Code
     * @param body Payload containing the TOTP code and user ID.
     * @return Verification success message.
     */
    verifyTwoFactor(body: VerifyTwoFactorDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/two-factor/verify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerifyTwoFactor(_response);
        });
    }

    protected processVerifyTwoFactor(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request if the payload is invalid.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized if the TOTP code is invalid.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Validates a Google sign in token and returns JWT token
     * @param body Google sign in token
     * @return JWT token for authenticated requests
     */
    googleTokenExchange(body: TokenExchangeDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/tokenexchange/google";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGoogleTokenExchange(_response);
        });
    }

    protected processGoogleTokenExchange(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, invalid Google sign in token", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when impersonating a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogin(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogin(_response);
        });
    }

    protected processImpersonateMemberLogin(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Generates a token for an admin when loggin out of a member
     * @param body User credentials for token generation
     * @return JWT token for authenticated requests
     */
    impersonateMemberLogout(body: ImpersonationDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/auth/impersonate/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateMemberLogout(_response);
        });
    }

    protected processImpersonateMemberLogout(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = JSON.parse(resultData401);
            return throwException("Unauthorized, incorrect email or password.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class BulkEmailClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all bulk email statuses.
     * @return List of bulk email statuses.
     */
    getAllBulkEmailStatuses( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBulkEmailStatuses(_response);
        });
    }

    protected processGetAllBulkEmailStatuses(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Process a bulk email
     * @param id The ID of the bulk email to process
     * @return The processed bulk email data
     */
    processBulkEmail(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}/process";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessBulkEmail(_response);
        });
    }

    protected processProcessBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad request response if processing fails", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Server error response", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve all bulk emails
     * @return The list of bulk emails
     */
    getBulkEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmails(_response);
        });
    }

    protected processGetBulkEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new bulk email
     * @param body The bulk email data to create
     * @return The newly created bulk email data
     */
    createBulkEmail(body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBulkEmail(_response);
        });
    }

    protected processCreateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Retrieve a bulk email by ID
     * @param id The ID of the bulk email to retrieve
     * @return The bulk email data
     */
    getBulkEmailById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBulkEmailById(_response);
        });
    }

    protected processGetBulkEmailById(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Update a bulk email by ID
     * @param id The ID of the bulk email to update
     * @param body The updated bulk email data
     * @return The updated bulk email data
     */
    updateBulkEmail(id: string, body: BulkEmailDTO, cancelToken?: CancelToken): Promise<ApiResponse_bulkEmailDTO> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBulkEmail(_response);
        });
    }

    protected processUpdateBulkEmail(response: AxiosResponse): Promise<ApiResponse_bulkEmailDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_bulkEmailDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_bulkEmailDTO>(null as any);
    }

    /**
     * Delete a bulk email by ID
     * @param id The ID of the bulk email to delete
     */
    deleteBulkEmail(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/bulkemails/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBulkEmail(_response);
        });
    }

    protected processDeleteBulkEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Upload a bulk email attachment
     * @param fileName (optional) Optional file name for saving the file. If not provided, a unique name will be generated.
     * @param body The raw file content to upload
     * @return The relative path of the uploaded file
     */
    uploadBulkEmailAttachment(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/bulkemails/attachments/upload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadBulkEmailAttachment(_response);
        });
    }

    protected processUploadBulkEmailAttachment(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request: Invalid file or missing parameters.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("An error occurred while uploading the file.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search bulk emails based on criteria
     * @param body The search criteria
     * @return The search results of bulk emails based on the criteria
     */
    searchBulkEmails(body: SearchRequestDTO_bulkEmailSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/bulkemails/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchBulkEmails(_response);
        });
    }

    protected processSearchBulkEmails(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class CommunicationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Unsubscribe an email using a token.
     * @param body Token data for unsubscribing an email.
     * @return Result of the unsubscribe action.
     */
    unsubscribeEmail(body: UnsubscribedEmailRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/communication/unsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribeEmail(_response);
        });
    }

    protected processUnsubscribeEmail(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Retrieve all unsubscribed emails.
     * @return List of unsubscribed emails.
     */
    getAllUnsubscribedEmails( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/unsubscribed-emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllUnsubscribedEmails(_response);
        });
    }

    protected processGetAllUnsubscribedEmails(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve all communication lists.
     * @return List of communication lists.
     */
    getAllCommunicationLists( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/communication/lists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCommunicationLists(_response);
        });
    }

    protected processGetAllCommunicationLists(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }
}

export class CompanyInfoClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Retrieve all company infos
     * @return The list of company infos
     */
    getCompanyInfos( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfos(_response);
        });
    }

    protected processGetCompanyInfos(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Create a new company info
     * @param body The company info data to create
     * @return The newly created data.
     */
    createCompanyInfo(body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCompanyInfo(_response);
        });
    }

    protected processCreateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Retrieve a company info by ID
     * @param id The ID of the company info to retrieve
     * @return The company info data
     */
    getCompanyInfoById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCompanyInfoById(_response);
        });
    }

    protected processGetCompanyInfoById(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Update a company info by ID
     * @param id The ID of the company info to update
     * @param body The updated company info data
     * @return The updated company info data.
     */
    updateCompanyInfo(id: string, body: CompanyInfoDTO, cancelToken?: CancelToken): Promise<ApiResponse_companyInfoDTO> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCompanyInfo(_response);
        });
    }

    protected processUpdateCompanyInfo(response: AxiosResponse): Promise<ApiResponse_companyInfoDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_companyInfoDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_companyInfoDTO>(null as any);
    }

    /**
     * Delete a company info by ID
     * @param id The ID of the company info to delete
     */
    deleteCompanyInfo(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/companyinfos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCompanyInfo(_response);
        });
    }

    protected processDeleteCompanyInfo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search company infos based on criteria
     * @param body The search criteria
     * @return The search results of company info based on the criteria
     */
    searchCompanyInfos(body: SearchRequestDTO_companyInfoSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/companyinfos/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCompanyInfos(_response);
        });
    }

    protected processSearchCompanyInfos(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }
}

export class MemberClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Open the current member's Stripe billing portal
     * @return The billing portal URL to redirect to
     */
    createMyBillingPortalSession( cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/me/billing-portal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMyBillingPortalSession(_response);
        });
    }

    protected processCreateMyBillingPortalSession(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Get the current member's payment status
     * @return The current member's membership status
     */
    getMyMembershipStatus( cancelToken?: CancelToken): Promise<ApiResponse_membershipStatusDTO> {
        let url_ = this.baseUrl + "/member/me/membership-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyMembershipStatus(_response);
        });
    }

    protected processGetMyMembershipStatus(response: AxiosResponse): Promise<ApiResponse_membershipStatusDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_membershipStatusDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_membershipStatusDTO>(null as any);
    }

    /**
     * Get or create the current member's outstanding invoice
     * @return The outstanding invoice's id
     */
    resumeMembership( cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/member/me/resume";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResumeMembership(_response);
        });
    }

    protected processResumeMembership(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Why the request was refused", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Retrieve all Members
     * @return The list of members
     */
    getMembers( cancelToken?: CancelToken): Promise<ApiResponse_iEnumerable_1> {
        let url_ = this.baseUrl + "/member";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMembers(_response);
        });
    }

    protected processGetMembers(response: AxiosResponse): Promise<ApiResponse_iEnumerable_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_iEnumerable_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_iEnumerable_1>(null as any);
    }

    /**
     * Retrieve a Member by ID
     * @param id The ID of the Member to retrieve
     * @return The Member data
     */
    getMemberById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMemberById(_response);
        });
    }

    protected processGetMemberById(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Update a Member by ID
     * @param id The ID of the Member to update
     * @param body The updated Member data
     * @return The updated Member data
     */
    updateMember(id: string, body: MemberDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberDTO> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMember(_response);
        });
    }

    protected processUpdateMember(response: AxiosResponse): Promise<ApiResponse_memberDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberDTO>(null as any);
    }

    /**
     * Delete a Member by ID
     * @param id The ID of the Member to delete
     */
    deleteMember(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/member/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMember(_response);
        });
    }

    protected processDeleteMember(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Register a new member
     * @param body The sign-up details
     * @return The newly registered member, already signed in
     */
    registerMember(body: MemberRegisterDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberRegisterResponseDTO> {
        let url_ = this.baseUrl + "/member/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterMember(_response);
        });
    }

    protected processRegisterMember(response: AxiosResponse): Promise<ApiResponse_memberRegisterResponseDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_memberRegisterResponseDTO>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Why the sign-up was refused", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            return throwException("An account with that email address already exists", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberRegisterResponseDTO>(null as any);
    }

    /**
     * Search Members based on criteria
     * @param body The search criteria
     * @return The search results of Members based on the criteria
     */
    searchMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/member/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchMembers(_response);
        });
    }

    protected processSearchMembers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Export Members based on search criteria
     * @param body The search criteria
     * @return The export results of Members based on the search criteria
     */
    exportMembers(body: SearchRequestDTO_memberSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMembers(_response);
        });
    }

    protected processExportMembers(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export class MemberProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Get the logged-in member's profile
     * @return The current member's profile
     */
    getMyProfile( cancelToken?: CancelToken): Promise<ApiResponse_memberProfileDTO> {
        let url_ = this.baseUrl + "/member/me/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyProfile(_response);
        });
    }

    protected processGetMyProfile(response: AxiosResponse): Promise<ApiResponse_memberProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberProfileDTO>(null as any);
    }

    /**
     * Save the logged-in member's profile
     * @param body The profile details
     * @return The saved profile
     */
    updateMyProfile(body: MemberProfileUpdateDTO, cancelToken?: CancelToken): Promise<ApiResponse_memberProfileDTO> {
        let url_ = this.baseUrl + "/member/me/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMyProfile(_response);
        });
    }

    protected processUpdateMyProfile(response: AxiosResponse): Promise<ApiResponse_memberProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_memberProfileDTO>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Why the change was refused", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            return throwException("Another account already uses that email address", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_memberProfileDTO>(null as any);
    }

    /**
     * Replace the logged-in member's profile picture
     * @param fileName (optional) The original file name, used for its extension
     * @param body The raw image file
     * @return A link to the new picture
     */
    uploadMyProfilePicture(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/member/me/profile-picture?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadMyProfilePicture(_response);
        });
    }

    protected processUploadMyProfilePicture(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Turn email on or off for the logged-in member
     * @param body Whether the member wants email
     * @return Whether email is now on
     */
    setMyEmailPreference(body: MemberEmailPreferenceDTO, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/member/me/email-preference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetMyEmailPreference(_response);
        });
    }

    protected processSetMyEmailPreference(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get the logged-in member's profile sharing state
     * @return The sharing state
     */
    getMyProfileShare( cancelToken?: CancelToken): Promise<ApiResponse_profileShareDTO> {
        let url_ = this.baseUrl + "/member/me/profile/share";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyProfileShare(_response);
        });
    }

    protected processGetMyProfileShare(response: AxiosResponse): Promise<ApiResponse_profileShareDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_profileShareDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_profileShareDTO>(null as any);
    }

    /**
     * Turn on sharing of the logged-in member's profile
     * @return The sharing state
     */
    shareMyProfile( cancelToken?: CancelToken): Promise<ApiResponse_profileShareDTO> {
        let url_ = this.baseUrl + "/member/me/profile/share";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShareMyProfile(_response);
        });
    }

    protected processShareMyProfile(response: AxiosResponse): Promise<ApiResponse_profileShareDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_profileShareDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_profileShareDTO>(null as any);
    }

    /**
     * Turn off sharing of the logged-in member's profile
     * @return The sharing state
     */
    stopSharingMyProfile( cancelToken?: CancelToken): Promise<ApiResponse_profileShareDTO> {
        let url_ = this.baseUrl + "/member/me/profile/share";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopSharingMyProfile(_response);
        });
    }

    protected processStopSharingMyProfile(response: AxiosResponse): Promise<ApiResponse_profileShareDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_profileShareDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_profileShareDTO>(null as any);
    }

    /**
     * Get a member's shared profile
     * @param shareId The share code from the link
     * @return The shared profile
     */
    getSharedProfile(shareId: string, cancelToken?: CancelToken): Promise<ApiResponse_sharedProfileDTO> {
        let url_ = this.baseUrl + "/shared/profile/{shareId}";
        if (shareId === undefined || shareId === null)
            throw new globalThis.Error("The parameter 'shareId' must be defined.");
        url_ = url_.replace("{shareId}", encodeURIComponent("" + shareId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSharedProfile(_response);
        });
    }

    protected processGetSharedProfile(response: AxiosResponse): Promise<ApiResponse_sharedProfileDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_sharedProfileDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_sharedProfileDTO>(null as any);
    }
}

export class UserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7165/api";

    }

    /**
     * Checks if an email exists.
     * @param email The email address.
     * @return Payload of ApiResponse containing Boolean
     */
    checkEmailExists(email: string, cancelToken?: CancelToken): Promise<ApiResponse_boolean> {
        let url_ = this.baseUrl + "/users/check-email?";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEmailExists(_response);
        });
    }

    protected processCheckEmailExists(response: AxiosResponse): Promise<ApiResponse_boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_boolean>(null as any);
    }

    /**
     * Get a user by ID
     * @param id The ID of the user to fetch
     * @return Payload of ApiResponse containing UserDTO
     */
    getUserById(id: string, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userDTO>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("User not found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Update an existing user
     * @return Payload of ApiResponse containing UserEditDTO
     */
    updateUser(id: string, body: UserEditDTO, cancelToken?: CancelToken): Promise<ApiResponse_userEditDTO> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ApiResponse_userEditDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_userEditDTO>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userEditDTO>(null as any);
    }

    /**
     * Deletes an existing user
     * @return Payload of ApiResponse containing String
     */
    deleteUser(id: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Search for users
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    searchUsers(body: SearchRequestDTO_userSearchRequestDTO, cancelToken?: CancelToken): Promise<ApiResponse_searchResponseDTO_1> {
        let url_ = this.baseUrl + "/user/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchUsers(_response);
        });
    }

    protected processSearchUsers(response: AxiosResponse): Promise<ApiResponse_searchResponseDTO_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_searchResponseDTO_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_searchResponseDTO_1>(null as any);
    }

    /**
     * Gets a list of all available permissions
     * @return Payload of ApiResponse containing SearchResponseDTO<UserDTO>
     */
    getAllPermissions( cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Gets permissions for a specific user
     * @param userId The ID of the user whose permissions to fetch
     * @return List of user's permissions
     */
    getUserPermissions(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_list_1> {
        let url_ = this.baseUrl + "/user/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<ApiResponse_list_1> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_list_1>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_list_1>(null as any);
    }

    /**
     * Create a new user
     * @return Payload of ApiResponse containing UserDTO
     */
    createUser(body: UserCreateDTO, cancelToken?: CancelToken): Promise<ApiResponse_userDTO> {
        let url_ = this.baseUrl + "/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ApiResponse_userDTO> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<ApiResponse_userDTO>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_userDTO>(null as any);
    }

    /**
     * Generates a password reset link
     * @return Payload of ApiResponse containing String
     */
    forgotPassword(body: ForgotPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Resets a user's password using a reset token
     * @return Payload of ApiResponse containing String
     */
    resetPassword(body: ResetPasswordDTO, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/user/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }

    /**
     * Uploads a users profile picture.
     * @param fileName (optional) The file name to use when saving the image
     * @param body The raw image file to upload
     * @return The FileRecord ID of the uploaded image
     */
    uploadProfilePicture(fileName: string | null | undefined, body: Blob, cancelToken?: CancelToken): Promise<ApiResponse_guid> {
        let url_ = this.baseUrl + "/user/upload-profile-picture?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProfilePicture(_response);
        });
    }

    protected processUploadProfilePicture(response: AxiosResponse): Promise<ApiResponse_guid> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_guid>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_guid>(null as any);
    }

    /**
     * Generates a SAS token for a user's profile picture.
     * @param userId The ID of the user.
     * @return The SAS URL for the profile picture.
     */
    generateProfilePictureSas(userId: string, cancelToken?: CancelToken): Promise<ApiResponse_string> {
        let url_ = this.baseUrl + "/users/{userId}/profile-picture";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateProfilePictureSas(_response);
        });
    }

    protected processGenerateProfilePictureSas(response: AxiosResponse): Promise<ApiResponse_string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ApiResponse_string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiResponse_string>(null as any);
    }
}

export interface ApiResponse_auditLogDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuditLogDTO | undefined;
}

export interface ApiResponse_authDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: AuthDTO | undefined;
}

export interface ApiResponse_boolean {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: boolean | undefined;
}

export interface ApiResponse_bulkEmailDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: BulkEmailDTO | undefined;
}

export interface ApiResponse_companyInfoDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CompanyInfoDTO | undefined;
}

export interface ApiResponse_countryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CountryDTO | undefined;
}

export interface ApiResponse_courseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseDTO | undefined;
}

export interface ApiResponse_courseMinifiedDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseMinifiedDTO | undefined;
}

export interface ApiResponse_courseMinifiedDTOOf {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseMinifiedDTO[] | undefined;
}

export interface ApiResponse_courseRequestDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CourseRequestDTO | undefined;
}

export interface ApiResponse_coursesPlayedShareDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CoursesPlayedShareDTO | undefined;
}

export interface ApiResponse_exploreManifestDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExploreManifestDTO | undefined;
}

export interface ApiResponse_exploreSnapshotResultDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ExploreSnapshotResultDTO | undefined;
}

export interface ApiResponse_fileUrlResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: FileUrlResponseDTO | undefined;
}

export interface ApiResponse_guid {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_iEnumerable_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: CountryDTO[] | undefined;
}

export interface ApiResponse_int32 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: number | undefined;
}

export interface ApiResponse_invoiceDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoiceDTO | undefined;
}

export interface ApiResponse_invoicePaymentSummaryDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: InvoicePaymentSummaryDTO | undefined;
}

export interface ApiResponse_list_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PermissionDTO[] | undefined;
}

export interface ApiResponse_memberBucketListDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberBucketListDTO | undefined;
}

export interface ApiResponse_memberBucketListSummaryDTOOf {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberBucketListSummaryDTO[] | undefined;
}

export interface ApiResponse_memberCoursesPlayedDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberCoursesPlayedDTO | undefined;
}

export interface ApiResponse_memberCoursesPlayedSummaryDTOOf {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberCoursesPlayedSummaryDTO[] | undefined;
}

export interface ApiResponse_memberDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberDTO | undefined;
}

export interface ApiResponse_memberFeeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberFeeDTO | undefined;
}

export interface ApiResponse_memberHomeCourseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberHomeCourseDTO | undefined;
}

export interface ApiResponse_memberHomeCourseSummaryDTOOf {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberHomeCourseSummaryDTO[] | undefined;
}

export interface ApiResponse_memberProfileDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberProfileDTO | undefined;
}

export interface ApiResponse_memberRegisterResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberRegisterResponseDTO | undefined;
}

export interface ApiResponse_membershipOptionDTOOf {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MembershipOptionDTO[] | undefined;
}

export interface ApiResponse_membershipStatusDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MembershipStatusDTO | undefined;
}

export interface ApiResponse_memberStatsDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberStatsDTO | undefined;
}

export interface ApiResponse_memberTypeDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: MemberTypeDTO | undefined;
}

export interface ApiResponse_pinDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: PinDTO | undefined;
}

export interface ApiResponse_profileShareDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: ProfileShareDTO | undefined;
}

export interface ApiResponse_searchResponseDTO_1 {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SearchResponseDTO_countryDTO | undefined;
}

export interface ApiResponse_sharedCoursesPlayedDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SharedCoursesPlayedDTO | undefined;
}

export interface ApiResponse_sharedProfileDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SharedProfileDTO | undefined;
}

export interface ApiResponse_stateDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: StateDTO | undefined;
}

export interface ApiResponse_string {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: string | undefined;
}

export interface ApiResponse_subRegionDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: SubRegionDTO | undefined;
}

export interface ApiResponse_twoFactorSetupResponseDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: TwoFactorSetupResponseDTO | undefined;
}

export interface ApiResponse_userDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserDTO | undefined;
}

export interface ApiResponse_userEditDTO {
    success?: boolean | undefined;
    message?: string | undefined;
    data?: UserEditDTO | undefined;
}

export interface AuditLogDTO {
    action?: string | undefined;
    tableName?: string | undefined;
    recordId?: string | undefined;
    propertyName?: string | undefined;
    oldValue?: string | undefined;
    newValue?: string | undefined;
    createdUtc?: string | undefined;
    updatedUtc?: string | undefined;
    changedBy?: string | undefined;
}

export interface AuditLogSearchRequestDTO {
    tableName?: string | undefined;
    recordId?: string | undefined;
    dateStart?: Date | undefined;
    dateEnd?: Date | undefined;
}

export interface AuthDTO {
    accessToken?: string | undefined;
    expiresAt?: number | undefined;
    refreshToken?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
}

export interface BulkEmailDTO {
    id?: string | undefined;
    subject?: string | undefined;
    title?: string | undefined;
    content?: string | undefined;
    bulkEmailStatusId?: string | undefined;
    communicationListId?: string | undefined;
    totalCount?: number | undefined;
    totalCountProcessed?: number | undefined;
    attachmentPath?: string | undefined;
    bulkEmailStatusName?: string | undefined;
    communicationListName?: string | undefined;
}

export interface BulkEmailSearchRequestDTO {
    subject?: string | undefined;
}

export interface CompanyInfoDTO {
    id?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
    taxNumber?: string | undefined;
    taxPercentage?: number | undefined;
}

export interface CompanyInfoSearchRequestDTO {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    bank?: string | undefined;
    accountType?: string | undefined;
    branchCode?: string | undefined;
    accountNumber?: string | undefined;
    swiftCode?: string | undefined;
    notes?: string | undefined;
    lastUsedInvoiceNumber?: number | undefined;
}

export interface CountryDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    code?: string | undefined;
    legacyCountryId?: number | undefined;
}

export interface CountrySearchRequestDTO {
    name?: string | undefined;
    code?: string | undefined;
    legacyCountryId?: number | undefined;
}

export interface CourseDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    address?: string | undefined;
    active?: boolean | undefined;
    closed?: boolean | undefined;
    closedYear?: number | undefined;
    closedMonth?: number | undefined;
    countryId?: string | undefined;
    stateId?: string | undefined;
    subRegionId?: string | undefined;
    logoFileId?: string | undefined;
    headerImageFileId?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    details?: string | undefined;
    timeZone?: string | undefined;
    teeOffTimes?: string | undefined;
    clubManagerName?: string | undefined;
    clubManagerEmail?: string | undefined;
    clubManagerPhoneNumber?: string | undefined;
    shopName?: string | undefined;
    shopEmail?: string | undefined;
    shopPhoneNumber?: string | undefined;
    proName?: string | undefined;
    proEmail?: string | undefined;
    proPhoneNumber?: string | undefined;
    designerName?: string | undefined;
    totalHoles?: number | undefined;
    description?: string | undefined;
    drivingRange?: boolean | undefined;
    practiceArea?: boolean | undefined;
    isSociety?: boolean | undefined;
    notes?: string | undefined;
    websiteUrl?: string | undefined;
    salesRep?: string | undefined;
    legacyCourseId?: number | undefined;
}

export interface CourseMinifiedDTO {
    id?: string | undefined;
    name?: string | undefined;
    address?: string | undefined;
    countryName?: string | undefined;
    stateName?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    logoFileId?: string | undefined;
    closed?: boolean | undefined;
    closedYear?: number | undefined;
    closedMonth?: number | undefined;
    logoUrl?: string | undefined;
    headerImageFileId?: string | undefined;
    headerImageUrl?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface CourseRequestCreateDTO {
    courseName?: string | undefined;
    countryId?: string | undefined;
    stateId?: string | undefined;
    websiteUrl?: string | undefined;
    notes?: string | undefined;
}

export interface CourseRequestDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    memberName?: string | undefined;
    memberEmail?: string | undefined;
    courseName?: string | undefined;
    location?: string | undefined;
    countryId?: string | undefined;
    countryName?: string | undefined;
    stateId?: string | undefined;
    stateName?: string | undefined;
    websiteUrl?: string | undefined;
    notes?: string | undefined;
    status?: CourseRequestDTOStatus | undefined;
    courseId?: string | undefined;
    resolvedCourseName?: string | undefined;
    reviewedByName?: string | undefined;
    reviewedUtc?: Date | undefined;
    reviewNotes?: string | undefined;
}

export interface CourseRequestReviewDTO {
    courseId?: string | undefined;
    reviewNotes?: string | undefined;
}

export interface CourseRequestSearchRequestDTO {
    courseName?: string | undefined;
    status?: CourseRequestSearchRequestDTOStatus | undefined;
}

export interface CourseSearchRequestDTO {
    name?: string | undefined;
    address?: string | undefined;
    active?: boolean | undefined;
    countryId?: string | undefined;
    stateId?: string | undefined;
    subRegionId?: string | undefined;
    logoFileId?: string | undefined;
    headerImageFileId?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    details?: string | undefined;
    timeZone?: string | undefined;
    teeOffTimes?: string | undefined;
    clubManagerName?: string | undefined;
    clubManagerEmail?: string | undefined;
    clubManagerPhoneNumber?: string | undefined;
    shopName?: string | undefined;
    shopEmail?: string | undefined;
    shopPhoneNumber?: string | undefined;
    proName?: string | undefined;
    proEmail?: string | undefined;
    proPhoneNumber?: string | undefined;
    designerName?: string | undefined;
    totalHoles?: number | undefined;
    description?: string | undefined;
    drivingRange?: boolean | undefined;
    practiceArea?: boolean | undefined;
    isSociety?: boolean | undefined;
    notes?: string | undefined;
    websiteUrl?: string | undefined;
    salesRep?: string | undefined;
    legacyCourseId?: number | undefined;
}

export interface CoursesPlayedShareDTO {
    shareId?: string | undefined;
}

export interface ExploreManifestDTO {
    version?: string | undefined;
    url?: string | undefined;
    count?: number | undefined;
    sizeBytes?: number | undefined;
    publishedUtc?: Date | undefined;
}

export interface ExploreSnapshotResultDTO {
    rebuilt?: boolean | undefined;
    reason?: string | undefined;
    manifest?: ExploreManifestDTO | undefined;
}

export interface FileUrlResponseDTO {
    url?: string | undefined;
    fileName?: string | undefined;
    contentType?: string | undefined;
    sizeInBytes?: number | undefined;
    status?: string | undefined;
}

export interface ForgotPasswordDTO {
    email: string;
}

export interface ImpersonationDTO {
    memberId?: string | undefined;
    adminId?: string | undefined;
}

export interface InvoiceDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    memberName?: string | undefined;
    memberEmail?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceStatusId?: string | undefined;
    issueDate?: Date | undefined;
    paidDate?: Date | undefined;
    totalExcl?: number | undefined;
    taxAmount?: number | undefined;
    totalIncl?: number | undefined;
    taxPercentage?: number | undefined;
    currency?: string | undefined;
    notes?: string | undefined;
    stripeCheckoutSessionId?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    invoiceLineItems?: InvoiceLineItemDTO[] | undefined;
}

export interface InvoiceLineItemDTO {
    id?: string | undefined;
    invoiceId?: string | undefined;
    memberFeeId?: string | undefined;
    description?: string | undefined;
    quantity?: number | undefined;
    unitPriceExcl?: number | undefined;
    lineExcl?: number | undefined;
    lineTax?: number | undefined;
    lineIncl?: number | undefined;
}

export interface InvoicePaymentSummaryDTO {
    invoiceId?: string | undefined;
    invoiceNumber?: string | undefined;
    isPaid?: boolean | undefined;
    memberFirstName?: string | undefined;
    description?: string | undefined;
    totalExcl?: number | undefined;
    taxAmount?: number | undefined;
    totalIncl?: number | undefined;
    taxPercentage?: number | undefined;
    currency?: string | undefined;
    issueDate?: Date | undefined;
}

export interface InvoiceSearchRequestDTO {
    memberId?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceStatusId?: string | undefined;
}

export interface LoginTwoFactorDTO {
    email?: string | undefined;
    tempToken?: string | undefined;
    code?: string | undefined;
}

export interface LoginUserDTO {
    email: string;
    password: string;
}

export interface MemberBucketListDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    courseId?: string | undefined;
    completed?: boolean | undefined;
    completedUtc?: Date | undefined;
    legacyBucketListId?: number | undefined;
}

export interface MemberBucketListSearchRequestDTO {
    memberId?: string | undefined;
    courseId?: string | undefined;
    completed?: boolean | undefined;
    completedUtc?: Date | undefined;
    legacyBucketListId?: number | undefined;
}

export interface MemberBucketListSummaryDTO {
    id?: string | undefined;
    courseId?: string | undefined;
    courseName?: string | undefined;
    courseAddress?: string | undefined;
    courseLogoFileId?: string | undefined;
    courseClosed?: boolean | undefined;
    courseClosedYear?: number | undefined;
    courseClosedMonth?: number | undefined;
    courseLatitude?: number | undefined;
    courseLongitude?: number | undefined;
    completed?: boolean | undefined;
    completedUtc?: Date | undefined;
}

export interface MemberCoursesPlayedDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    courseId?: string | undefined;
    rating?: number | undefined;
    rankOrder?: number | undefined;
    pinId?: string | undefined;
    legacyCoursesPlayedId?: number | undefined;
}

export interface MemberCoursesPlayedPlaceRequestDTO {
    sentiment?: number | undefined;
    position?: number | undefined;
}

export interface MemberCoursesPlayedRankRequestDTO {
    courseIds?: string[] | undefined;
    movedCourseId?: string | undefined;
}

export interface MemberCoursesPlayedSearchRequestDTO {
    memberId?: string | undefined;
    courseId?: string | undefined;
    rating?: number | undefined;
    pinId?: string | undefined;
    legacyCoursesPlayedId?: number | undefined;
}

export interface MemberCoursesPlayedSummaryDTO {
    id?: string | undefined;
    courseId?: string | undefined;
    courseName?: string | undefined;
    courseAddress?: string | undefined;
    courseLogoFileId?: string | undefined;
    courseClosed?: boolean | undefined;
    courseClosedYear?: number | undefined;
    courseClosedMonth?: number | undefined;
    courseLatitude?: number | undefined;
    courseLongitude?: number | undefined;
    countryId?: string | undefined;
    countryName?: string | undefined;
    stateId?: string | undefined;
    stateName?: string | undefined;
    rating?: number | undefined;
    rankOrder?: number | undefined;
    sentiment?: number | undefined;
    score?: number | undefined;
    pinId?: string | undefined;
    pinName?: string | undefined;
    createdUtc?: Date | undefined;
}

export interface MemberDTO {
    id?: string | undefined;
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    userID?: string | undefined;
    stripeCustomerId?: string | undefined;
    memberTypeId?: string | undefined;
    active?: boolean | undefined;
    paidUntilUtc?: Date | undefined;
    memberTypeName?: string | undefined;
    lastLoginUtc?: Date | undefined;
}

export interface MemberEmailPreferenceDTO {
    receiveEmails?: boolean | undefined;
}

export interface MemberFeeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberTypeId?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    billingFrequencyId?: string | undefined;
    stripePriceId?: string | undefined;
    stripeProductId?: string | undefined;
    isActive?: boolean | undefined;
}

export interface MemberFeeSearchRequestDTO {
    memberTypeId?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    billingFrequencyId?: string | undefined;
    stripePriceId?: string | undefined;
    stripeProductId?: string | undefined;
    isActive?: boolean | undefined;
}

export interface MemberHomeCourseDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    memberId?: string | undefined;
    courseId?: string | undefined;
    private?: boolean | undefined;
    legacyHomeCourseId?: number | undefined;
}

export interface MemberHomeCourseSearchRequestDTO {
    memberId?: string | undefined;
    courseId?: string | undefined;
    private?: boolean | undefined;
    legacyHomeCourseId?: number | undefined;
}

export interface MemberHomeCourseSummaryDTO {
    id?: string | undefined;
    courseId?: string | undefined;
    courseName?: string | undefined;
    courseAddress?: string | undefined;
    courseLogoFileId?: string | undefined;
    courseClosed?: boolean | undefined;
    courseClosedYear?: number | undefined;
    courseClosedMonth?: number | undefined;
    courseLatitude?: number | undefined;
    courseLongitude?: number | undefined;
    private?: boolean | undefined;
    isPrimary?: boolean | undefined;
}

export interface MemberHomeCourseVisibilityDTO {
    hidden?: boolean | undefined;
}

export interface MemberProfileDTO {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    profilePictureUrl?: string | undefined;
    about?: string | undefined;
    dateOfBirth?: Date | undefined;
    genderId?: string | undefined;
    genderName?: string | undefined;
    countryName?: string | undefined;
    stateName?: string | undefined;
    handicapIndex?: number | undefined;
    gamblePreference?: number | undefined;
    paceOfPlay?: number | undefined;
    languages?: string[] | undefined;
    playsAsCouple?: boolean | undefined;
    receiveEmails?: boolean | undefined;
    hasBillingAccount?: boolean | undefined;
    genderOptions?: ProfileOptionDTO[] | undefined;
}

export interface MemberProfileUpdateDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    about?: string | undefined;
    dateOfBirth?: Date | undefined;
    genderId?: string | undefined;
    handicapIndex?: number | undefined;
    gamblePreference?: number | undefined;
    paceOfPlay?: number | undefined;
    languages?: string[] | undefined;
    playsAsCouple?: boolean | undefined;
}

export interface MemberRegisterDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    memberTypeId?: string | undefined;
}

export interface MemberRegisterResponseDTO {
    member?: MemberDTO | undefined;
    auth?: AuthDTO | undefined;
}

export interface MemberSearchRequestDTO {
    membershipNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface MembershipOptionDTO {
    memberTypeId?: string | undefined;
    memberTypeName?: string | undefined;
    description?: string | undefined;
    memberFeeId?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    billingFrequencyName?: string | undefined;
}

export interface MembershipStatusDTO {
    active?: boolean | undefined;
    memberTypeId?: string | undefined;
    memberTypeName?: string | undefined;
    paidUntilUtc?: Date | undefined;
}

export interface MemberStatsDTO {
    coursesPlayed?: number | undefined;
    coursesPlayedThisMonth?: number | undefined;
    countriesPlayed?: number | undefined;
    countriesPlayedThisMonth?: number | undefined;
    statesPlayed?: number | undefined;
    statesPlayedThisMonth?: number | undefined;
    courseLastAddedUtc?: Date | undefined;
    homeCourses?: number | undefined;
    bucketList?: number | undefined;
}

export interface MemberTypeDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    displayOrder?: number | undefined;
}

export interface MemberTypeSearchRequestDTO {
    name?: string | undefined;
    description?: string | undefined;
    isActive?: boolean | undefined;
    displayOrder?: number | undefined;
}

export interface PermissionDTO {
    name?: string | undefined;
    category?: string | undefined;
    entity?: string | undefined;
    action?: string | undefined;
}

export interface PinDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    legacyPinId?: number | undefined;
}

export interface PinSearchRequestDTO {
    name?: string | undefined;
    legacyPinId?: number | undefined;
}

export interface ProfileOptionDTO {
    id?: string | undefined;
    name?: string | undefined;
}

export interface ProfileShareDTO {
    shareId?: string | undefined;
}

export interface RefreshTokenDTO {
    refreshToken?: string | undefined;
}

export interface ResetPasswordDTO {
    email?: string | undefined;
    token?: string | undefined;
    newPassword?: string | undefined;
}

export interface SearchRequestDTO_auditLogSearchRequestDTO {
    filters?: AuditLogSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_bulkEmailSearchRequestDTO {
    filters?: BulkEmailSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_companyInfoSearchRequestDTO {
    filters?: CompanyInfoSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_countrySearchRequestDTO {
    filters?: CountrySearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseRequestSearchRequestDTO {
    filters?: CourseRequestSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_courseSearchRequestDTO {
    filters?: CourseSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_invoiceSearchRequestDTO {
    filters?: InvoiceSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberBucketListSearchRequestDTO {
    filters?: MemberBucketListSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberCoursesPlayedSearchRequestDTO {
    filters?: MemberCoursesPlayedSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberFeeSearchRequestDTO {
    filters?: MemberFeeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberHomeCourseSearchRequestDTO {
    filters?: MemberHomeCourseSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberSearchRequestDTO {
    filters?: MemberSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_memberTypeSearchRequestDTO {
    filters?: MemberTypeSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_pinSearchRequestDTO {
    filters?: PinSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_stateSearchRequestDTO {
    filters?: StateSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_subRegionSearchRequestDTO {
    filters?: SubRegionSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchRequestDTO_userSearchRequestDTO {
    filters?: UserSearchRequestDTO | undefined;
    page?: number | undefined;
    pageSize?: number | undefined;
    sortBy?: string | undefined;
    sortDescending?: boolean | undefined;
}

export interface SearchResponseDTO_countryDTO {
    results?: CountryDTO[] | undefined;
    totalCount?: number | undefined;
}

export interface SharedCoursePlayedDTO {
    rank?: number | undefined;
    courseId?: string | undefined;
    courseName?: string | undefined;
    stateName?: string | undefined;
    countryName?: string | undefined;
    logoUrl?: string | undefined;
    hasProfile?: boolean | undefined;
    closed?: boolean | undefined;
    closedYear?: number | undefined;
    closedMonth?: number | undefined;
}

export interface SharedCoursesPlayedDTO {
    ownerName?: string | undefined;
    ownerPictureUrl?: string | undefined;
    courses?: SharedCoursePlayedDTO[] | undefined;
}

export interface SharedHomeClubDTO {
    courseId?: string | undefined;
    courseName?: string | undefined;
    logoUrl?: string | undefined;
    hasProfile?: boolean | undefined;
    closed?: boolean | undefined;
}

export interface SharedProfileDTO {
    displayName?: string | undefined;
    pictureUrl?: string | undefined;
    about?: string | undefined;
    coursesPlayed?: number | undefined;
    countriesPlayed?: number | undefined;
    bucketList?: number | undefined;
    handicapIndex?: number | undefined;
    stateName?: string | undefined;
    countryName?: string | undefined;
    gamblePreference?: number | undefined;
    paceOfPlay?: number | undefined;
    languages?: string[] | undefined;
    playsAsCouple?: boolean | undefined;
    homeClub?: SharedHomeClubDTO | undefined;
    coursesPlayedShareId?: string | undefined;
}

export interface StateDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    code?: string | undefined;
    countryId?: string | undefined;
    legacyStateId?: number | undefined;
}

export interface StateSearchRequestDTO {
    name?: string | undefined;
    code?: string | undefined;
    countryId?: string | undefined;
    legacyStateId?: number | undefined;
}

export interface SubRegionDTO {
    id?: string | undefined;
    createdUtc?: Date | undefined;
    name?: string | undefined;
    code?: string | undefined;
    countryId?: string | undefined;
    stateId?: string | undefined;
    legacySubRegionId?: number | undefined;
}

export interface SubRegionSearchRequestDTO {
    name?: string | undefined;
    code?: string | undefined;
    countryId?: string | undefined;
    stateId?: string | undefined;
    legacySubRegionId?: number | undefined;
}

export interface TokenExchangeDTO {
    token?: string | undefined;
}

export interface TwoFactorSetupResponseDTO {
    qrCodeUrl?: string | undefined;
}

export interface UnsubscribedEmailRequestDTO {
    token?: string | undefined;
    reason?: string | undefined;
}

export interface UserCreateDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    password?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureFileId?: string | undefined;
    permissions?: string[] | undefined;
}

export interface UserDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureFileId?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    permissions?: string[] | undefined;
}

export interface UserEditDTO {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    profilePictureFileId?: string | undefined;
    twoFactorEnabled?: boolean | undefined;
    permissions?: string[] | undefined;
}

export interface UserSearchRequestDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    role?: string | undefined;
}

export interface VerifyTwoFactorDTO {
    userId?: string | undefined;
    code?: string | undefined;
}

export enum CourseRequestDTOStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum CourseRequestSearchRequestDTOStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}